export default "__VITE_ASSET__dNiN37hA__"